import { useContext } from 'react';
import {
    CalculatorInputFields,
    CalculatorInputFieldsType,
    CalculatorInputOptions,
} from '../utils/CalculatorInputValue';
import { CalculatorFieldsContext, CalculatorOutputFieldsContext } from '../contexts/CalculatorContext';
import {
    CalculatorAdvancedModeContext,
    CalculatorCurrencyContext,
    CalculatorHtmModeContext
} from '../../../shared/contexts/CalculatorContext';
import { CalculatorAdvancedMode, CalculatorHTMMode } from '../../../shared/classes/CalculatorMode';
import { CalculatorOutputFields } from '../utils/CalculatorOutputValue';
import { CalculatorOptions } from '../../../shared/classes/CalculatorOptions';

export function SharedInputEdit({inputName}: { inputName: keyof CalculatorInputFieldsType }): JSX.Element | null {
    const [calculatorValue, setCalculatorValue] = useContext(CalculatorFieldsContext)!;
    const calculatorMode = useContext(CalculatorHtmModeContext)!;
    const calculatorCurrencyContext = useContext(CalculatorCurrencyContext)!;
    const label = CalculatorInputFields.find(e => e.key === inputName)?.label;
    const options = CalculatorInputOptions[inputName];
    const currency = options?.displayCurrency ? calculatorCurrencyContext[0] : '';
    const isAdvancedMode = options?.isHTMMode || false;
    const maxValue = options?.maxValue;
    const uniqInputName = 'input_' + inputName;
    const selectedValue = calculatorValue[inputName];
    const error = selectedValue && maxValue && !Number.isNaN(selectedValue) && (selectedValue > maxValue);

    return !isAdvancedMode || calculatorMode[0] === CalculatorHTMMode.HTM
        ? (
            <div className={(error ? 'error ' : '') + (isAdvancedMode ? 'advancedMode ' : '') + 'inputValue'}>
                <label htmlFor={uniqInputName}>{label}</label>
                <div>{ currency ? <span>{currency}</span> : '' }</div>
                <input name={inputName} id={uniqInputName}
                       type="number"
                       max={maxValue}
                       onChange={event => setCalculatorValue({
                           ...calculatorValue,
                           [inputName]: (maxValue ? Math.min(+event.target.value, maxValue) : +event.target.value)
                       })}
                       value={selectedValue || ''}/>
                {
                    error
                        ? <small className="msg-error">Value shouldn't be over {maxValue}</small>
                        : ''
                }
            </div>
        )
        : null;
}

export function SharedOutputEditComponent({inputName}: { inputName: keyof CalculatorOutputFields['values']}): JSX.Element | null {
    const calculatorHTMMode = useContext(CalculatorHtmModeContext)!;
    const calculatorAdvancedMode = useContext(CalculatorAdvancedModeContext)!;
    const calculatorCurrencyContext = useContext(CalculatorCurrencyContext)!;
    const calculatorOutputFieldsContext = useContext(CalculatorOutputFieldsContext)!;
    const calculatorField = calculatorOutputFieldsContext.values[inputName];
    const {label, value} = calculatorField;
    let options: CalculatorOptions | null = null;

    if ('options' in calculatorField) {
        options = calculatorField.options;
    }

    const currency = options?.displayCurrency ? calculatorCurrencyContext[0] : '';
    const isHTMMode = options?.isHTMMode || false;
    const isAdvancedMode = options?.isAdvancedMode || false;
    let selectedValue = (options?.round === false ? Math.round((value || 0) * 100) / 100 : Math.round(value || 0)).toString();

    if (currency) {
        selectedValue = selectedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    return (!isHTMMode || calculatorHTMMode[0] === CalculatorHTMMode.HTM)
        && (!isAdvancedMode || calculatorAdvancedMode[0] === CalculatorAdvancedMode.Advanced)
        ? (
            <div className="inputValue">
                <label htmlFor={inputName}>{label}</label>
                <div>{ currency ? <span>{currency}</span> : '' }</div>
                <input name={inputName}
                       readOnly
                       type="text"
                       value={selectedValue}/>
            </div>
        )
        : null;
}
